var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.tileLinkUrl},on:{"click":_vm.onClick}},[_c('div',{class:{
      tile: true,
      'tile--selected': _vm.selected,
      'tile--thumbnail': _vm.isThumbnail,
    }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }